/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchSessions } from '../services/graphqlService';

const SessionsContext = createContext();

const fetchSessionsData = async () => {
  const data = await fetchSessions();
  return data?.data?.connectSessionList?.items || data?.data?.sessionList?.items || [];
};

export const SessionsProvider = ({ children }) => {
  const { data: sessions = [], isLoading: loading } = useQuery({
    queryKey: ['sessions'],
    queryFn: fetchSessionsData,
    staleTime: 10 * 60 * 1000, // 10min
  });

  return (
    <SessionsContext.Provider value={{ sessions, loading }}>
      {children}
    </SessionsContext.Provider>
  );
};

export const useSessions = () => {
  const context = useContext(SessionsContext);
  if (!context) {
    throw new Error('useSessions must be used within SessionsProvider');
  }
  return context;
};
